module.exports = __webpack_public_path__ + "img/m11-Coca-Cola.18771b49.png";